import kep1 from "./kep1.png"
import kep2 from "./kep2.png"
import kep3 from "./kep3.jpg"
import logo from "./logo.jpg"

const images = {
    kep1, kep2, kep3, logo
}
export default images